import React, { useState, useEffect } from "react";
import axios from 'axios';
import './Invoice.css';

const NewInvoiceForm = ({ onInvoiceCreated, onCancel, currentUserFullName }) => {
    const userType = localStorage.getItem("usertype");
    const loggedInUserId = localStorage.getItem("id") || localStorage.getItem("user_id");

    const [formData, setFormData] = useState({
        ref_no: '',
        client_id: '',
        stock_id: '',
        invoice_date: '',
        due_date: '',
        discount_type: 'No Discount',
        assigned_to_type: 'customize',
        group_id: 0,
        reporter: currentUserFullName || 'Super Admin',
        chassis: '',
        remarks: '',
        bl_surrender_date: '',
        sales_agent: '',
        allow_paypal: false,
        allow_paytmoney: false,
        notes: '',
        show_quantity_as: 'Qty',
        sub_total: '0.00',
        discount: '0.00',
        adjustment: '0.00',
        total: '0.00',
        mode: 'create'
    });

    const [clientsData, setClientsData] = useState([]);
    const [stocksData, setStocksData] = useState([]);
    const [availableChassis, setAvailableChassis] = useState([]);
    const [usersData, setUsersData] = useState([]);
    const [groupsData, setGroupsData] = useState({ administrators: [], groups: [] });
    const [selectedGroupId, setSelectedGroupId] = useState('');
    const [permissions, setPermissions] = useState({});
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [filteredStocks, setFilteredStocks] = useState([]);
    const [saleOrdersData, setSaleOrdersData] = useState([]);
    const [filteredChassis, setFilteredChassis] = useState([]);

    useEffect(() => {
        fetchClients();
        fetchStocks();
        fetchSaleOrders();
        fetchAvailableChassis();
        fetchUsers();

        if (!formData.ref_no) {
            fetchGeneratedRef();
        }

        if (formData.assigned_to_type === 'customize' && groupsData.groups.length === 0) fetchGroups();
    }, [formData.assigned_to_type]);

    // ===== FETCH AUTO-GENERATED REF NO =====
    const fetchGeneratedRef = async () => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get('https://skcapi.btcjapan.co/get_generated_ref.php', {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (res.data.success) {
                setFormData(prev => ({ ...prev, ref_no: res.data.ref_no }));
            }
        } catch (err) {
            console.error("Error fetching Ref No:", err);
        }
    };

    const fetchAvailableChassis = async () => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get('https://skcapi.btcjapan.co/get_available_chassis.php', { headers: { Authorization: `Bearer ${token}` } });
            if (res.data.success) {
                setAvailableChassis(res.data.data);
                setFilteredChassis(res.data.data);
            }
        } catch (err) { console.error("Error fetching chassis:", err); }
    };

    const fetchClients = async () => {
        try { const token = localStorage.getItem("token"); const res = await axios.get('https://skcapi.btcjapan.co/get_clients.php', { headers: { Authorization: `Bearer ${token}` } }); if (res.data.success) setClientsData(res.data.data); } catch (err) { console.error(err); }
    };

    const fetchStocks = async () => {
        try { const token = localStorage.getItem("token"); const res = await axios.get('https://skcapi.btcjapan.co/get_stock.php', { headers: { Authorization: `Bearer ${token}` } }); if (res.data.success) setStocksData(res.data.data); } catch (err) { console.error(err); }
    };

    const fetchSaleOrders = async () => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get('https://skcapi.btcjapan.co/get_sale_orders.php', { headers: { Authorization: `Bearer ${token}` } });
            if (res.data.success) setSaleOrdersData(res.data.data);
        } catch (err) { console.error(err); }
    };

    const fetchUsers = async () => {
        try { const res = await axios.get('https://skcapi.btcjapan.co/fetch_users.php'); if (res.data.Status === "200") setUsersData(res.data.Users); } catch (err) { console.error(err); }
    };

    const fetchGroups = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get('https://skcapi.btcjapan.co/get_groups_with_members.php', {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (res.data.success) setGroupsData(res.data);
        } catch (err) { console.error(err); } finally { setLoading(false); }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));

        // ===== CASCADING DROPDOWN LOGIC (Stock & Chassis) =====
        if (name === 'client_id') {
            const clientOrderChassis = saleOrdersData
                .filter(order => String(order.client_id) === String(value))
                .map(order => order.chassis_number)
                .filter(Boolean);

            const selectedClientStocks = stocksData.filter(stock =>
                clientOrderChassis.includes(stock.chassis_number)
            );
            setFilteredStocks(selectedClientStocks);

            const filteredChassisList = availableChassis.filter(chassis => {
                const chassisValue = typeof chassis === 'string' ? chassis : chassis.chassis_number;
                return clientOrderChassis.includes(chassisValue);
            });
            setFilteredChassis(filteredChassisList);

            setFormData(prev => ({ ...prev, stock_id: '', chassis: '' }));
            setItems([]);
            setFormData(prev => ({ ...prev, sub_total: '0.00', total: '0.00' }));
        }

        if (name === 'assigned_to_type' && value === 'customize') setSelectedGroupId('');
    };

    const handleGroupChange = (e) => {
        const groupId = e.target.value;
        setSelectedGroupId(groupId);
        if (!groupId) { setPermissions({}); return; }

        const group = groupsData.groups.find(g => g.group_id == groupId);
        if (!group) return;

        const newPermissions = {};
        groupsData.administrators.forEach(admin => {
            newPermissions[admin.id] = { can_view: true, can_edit: true, can_delete: true, is_auto: true };
        });
        if (group.leader_id) {
            newPermissions[group.leader_id] = { can_view: true, can_edit: true, can_delete: true, is_auto: true };
        }

        setPermissions(prev => {
            const merged = { ...newPermissions };
            Object.keys(prev).forEach(uid => {
                if (!merged[uid] && !prev[uid].is_auto) { merged[uid] = prev[uid]; }
            });
            return merged;
        });
    };

    const toggleMember = (userId, checked) => {
        if (checked) {
            setPermissions(prev => ({
                ...prev,
                [userId]: { can_view: true, can_edit: false, can_delete: false, is_auto: false }
            }));
        } else {
            setPermissions(prev => {
                const copy = { ...prev };
                if (copy[userId]?.is_auto) return prev;
                delete copy[userId];
                return copy;
            });
        }
    };

    const handlePermissionChange = (userId, permType, checked) => {
        setPermissions(prev => {
            const current = prev[userId] || { can_view: false, can_edit: false, can_delete: false };
            return { ...prev, [userId]: { ...current, [permType]: checked } };
        });
    };

    const addItem = () => {
        setItems([...items, { item_name: '', description: '', qty: 1, price: '', tax_rate: 'No Tax', total: '0.00' }]);
    };

    const handleItemChassisChange = (index, chassisValue) => {
        const updatedItems = [...items];
        updatedItems[index].item_name = chassisValue;

        const selectedStock = stocksData.find(s => s.chassis_number === chassisValue);
        if (selectedStock) {
            updatedItems[index].description = selectedStock.stock_name || '';
            updatedItems[index].qty = 1;
            updatedItems[index].price = selectedStock.sale_price || '0.00';
            updatedItems[index].total = (updatedItems[index].qty * parseFloat(selectedStock.sale_price || 0)).toFixed(2);
        }

        setFormData(prev => ({ ...prev, chassis: chassisValue }));
        setItems(updatedItems);
        calculateTotals(updatedItems);
    };

    const handleItemChange = (index, field, value) => {
        const updatedItems = [...items];
        updatedItems[index] = { ...updatedItems[index], [field]: value };
        const qty = parseFloat(updatedItems[index].qty) || 0;
        const price = parseFloat(updatedItems[index].price) || 0;
        updatedItems[index].total = (qty * price).toFixed(2);
        setItems(updatedItems);
        calculateTotals(updatedItems);
    };

    const removeItem = (index) => {
        if (items.length > 0) {
            const updatedItems = items.filter((_, i) => i !== index);
            setItems(updatedItems);
            calculateTotals(updatedItems);
        }
    };

    const calculateTotals = (updatedItems) => {
        let subTotal = 0;
        updatedItems.forEach(item => { subTotal += parseFloat(item.total) || 0; });
        const discount = parseFloat(formData.discount) || 0;
        const adjustment = parseFloat(formData.adjustment) || 0;
        const total = subTotal - discount + adjustment;
        setFormData(prev => ({ ...prev, sub_total: subTotal.toFixed(2), total: total.toFixed(2) }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (items.length === 0) { alert("Please add at least one item."); return; }

        setSaving(true);
        try {
            const token = localStorage.getItem("token");
            let permissionsPayload = [];
            if (formData.assigned_to_type === 'customize') {
                if (!selectedGroupId) { alert("Please select a group"); setSaving(false); return; }
                permissionsPayload = Object.entries(permissions).map(([userId, perms]) => ({ user_id: parseInt(userId), can_view: perms.can_view ? 1 : 0, can_edit: perms.can_edit ? 1 : 0, can_delete: perms.can_delete ? 1 : 0 }));
            }
            const payload = { ...formData, group_id: selectedGroupId ? parseInt(selectedGroupId, 10) : 0, permissions: permissionsPayload, items };

            const response = await axios.post('https://skcapi.btcjapan.co/create_update_invoice.php', payload, {
                headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
            });

            if (response.data.success) {
                alert('Invoice saved successfully!');
                if (onInvoiceCreated) onInvoiceCreated(response.data);
                window.location.href = `/view-invoice`;
            }
        } catch (err) { console.error(err); alert("Error saving Invoice."); } finally { setSaving(false); }
    };

    let displayGroups = [];
    if (userType === 'administrator') displayGroups = groupsData.groups;
    else if (userType === 'leader') displayGroups = groupsData.groups.filter(g => String(g.leader_id) === String(loggedInUserId));
    else if (userType === 'member') displayGroups = groupsData.groups.filter(group => group.members.some(m => String(m.id) === String(loggedInUserId)));

    const selectedGroup = displayGroups.find(g => g.group_id == selectedGroupId);
    const selectedGroupName = displayGroups.find(g => g.group_id == selectedGroupId);

    useEffect(() => {
        if (selectedGroupName && selectedGroupName.leader_name) setFormData(prev => ({ ...prev, reporter: selectedGroupName.leader_name }));
    }, [selectedGroupName]);

    useEffect(() => {
        if (userType === 'member' && selectedGroup) {
            const isMemberInGroup = selectedGroup.members.some(m => String(m.id) === String(loggedInUserId));
            if (isMemberInGroup && !permissions[loggedInUserId]) setPermissions(prev => ({ ...prev, [loggedInUserId]: { can_view: true, can_edit: false, can_delete: false, is_auto: true } }));
        }
    }, [selectedGroup, loggedInUserId, userType]);

    return (
        <div className="new-invoice-form-container">
            <form onSubmit={handleSubmit} className="sale-order-form">

                {/* ===== HERO SECTION ===== */}
                <div className="sale-form-hero">
                    <div>
                        <div className="sale-form-eyebrow">
                            <span className="eyebrow-dot"></span>
                            NEW INVOICE
                            <span className="ref-chip">{formData.ref_no}</span>
                        </div>
                        <h2>Create Invoice & Payment Document</h2>
                        <p>Fill in the customer & financial details below to generate this document.</p>
                    </div>
                    <div className="sale-form-hero-actions">
                        <div className="document-status-control">
                            <span>Document Status:</span>
                            <select name="status" value={formData.status} onChange={handleChange}>
                                <option>Draft</option><option>Sent</option><option>Open</option><option>Revised</option><option>Decline</option><option>Accepted</option>
                            </select>
                        </div>
                        <button type="submit" className="btn-blue hero-save-btn">Save Invoice</button>
                    </div>
                </div>

                {/* ===== CLIENT & FINANCIAL INFO ===== */}
                <div className="form-section-card">
                    <div className="section-card-heading compact">
                        <div className="section-title-wrap">
                            <div className="section-icon">📦</div>
                            <div>
                                <h3>Client & Financial Information</h3>
                                <p>Provide the necessary client & invoice details.</p>
                            </div>
                        </div>
                    </div>

                    <div className="form-fields-grid form-fields-grid-3">
                        <div className="form-group">
                            <label>Ref No <span>*</span></label>
                            <input type="text" name="ref_no" value={formData.ref_no} readOnly={true} placeholder="Auto-generated" />
                        </div>
                        <div className="form-group">
                            <label>Client <span>*</span></label>
                            <select name="client_id" value={formData.client_id} onChange={handleChange}>
                                <option value="">-- Select Client --</option>
                                {clientsData.map(client => <option key={client.id} value={client.id}>{client.client_name}</option>)}
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Stock</label>
                            <select name="stock_id" value={formData.stock_id} onChange={handleChange}>
                                <option value="">-- Select Stock --</option>
                                {filteredStocks.map(stock => <option key={stock.id} value={stock.id}>{stock.stock_name} - {stock.chassis_number}</option>)}
                            </select>
                        </div>

                        <div className="form-group">
                            <label>Invoice Date</label>
                            <input type="date" name="invoice_date" value={formData.invoice_date} onChange={handleChange} />
                        </div>
                        <div className="form-group">
                            <label>Due Date</label>
                            <input type="date" name="due_date" value={formData.due_date} onChange={handleChange} />
                        </div>
                        <div className="form-group">
                            <label>BL Surrender Date</label>
                            <input type="date" name="bl_surrender_date" value={formData.bl_surrender_date} onChange={handleChange} />
                        </div>

                        <div className="form-group">
                            <label>Discount Type</label>
                            <select name="discount_type" value={formData.discount_type} onChange={handleChange}>
                                <option>No Discount</option><option>Before Tax</option><option>After Tax</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Sales Agent</label>
                            <select name="sales_agent" value={formData.sales_agent} onChange={handleChange}>
                                <option value="">Super Admin</option>
                                {usersData.filter(u => u.usertype === 'administrator' || u.usertype === 'leader' || u.usertype === 'member').map(u => <option key={u.id} value={`${u.fname} ${u.lname}`}>{u.fname} {u.lname}</option>)}
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Remarks</label>
                            <textarea rows="2" name="remarks" value={formData.remarks} onChange={handleChange} />
                        </div>
                    </div>

                    <div className="checkbox-group" style={{ display: 'flex', gap: '20px', marginTop: '10px' }}>
                        <label><input type="checkbox" name="allow_paypal" checked={formData.allow_paypal} onChange={handleChange} /> Allow PayPal</label>
                        <label><input type="checkbox" name="allow_paytmoney" checked={formData.allow_paytmoney} onChange={handleChange} /> Allow PayUmoney</label>
                    </div>
                </div>

                {/* ===== PERMISSION ACCESS ===== */}
                <div className="form-section-card permission-section-card">
                    <div className="section-card-heading">
                        <div className="section-title-wrap">
                            <div className="section-icon">🔐</div>
                            <div>
                                <h3>Permission Access</h3>
                                <p>Assign this document to specific users or groups.</p>
                            </div>
                        </div>
                        <div className="assigned-radio-group">
                            {/* 
                            <label className="assigned-radio-option permission-choice">
                                <input type="radio" name="assigned_to_type" value="everyone" checked={formData.assigned_to_type === 'everyone'} onChange={handleChange} />
                                <span><strong>Everyone</strong><small>All users can view</small></span>
                            </label>
                            */}
                            {(userType === 'administrator' || userType === 'leader') && (
                                <label className="assigned-radio-option permission-choice">
                                    <input type="radio" name="assigned_to_type" value="customize" checked={formData.assigned_to_type === 'customize'} onChange={handleChange} />
                                    <span><strong>Customize Permission</strong><small>Assign to group</small></span>
                                </label>
                            )}
                        </div>
                    </div>

                    {formData.assigned_to_type === 'customize' && (
                        <div className="permission-panel">
                            {loading ? <p className="permission-panel-loading">Loading groups...</p> : (
                                <>
                                    <div className="group-select-block">
                                        <label>Select Group <span>*</span></label>
                                        <select value={selectedGroupId} onChange={handleGroupChange}>
                                            <option value="">-- Select a Group --</option>
                                            {displayGroups.map(g => <option key={g.group_id} value={g.group_id}>{g.group_name}</option>)}
                                        </select>
                                        {displayGroups.length === 0 && <p className="group-empty-msg">No groups available for your account.</p>}
                                    </div>

                                    {selectedGroup && (
                                        <div className="permission-scroll">
                                            <div className="role-block">
                                                <p className="role-block-title admin">Administrators <span>(Auto)</span></p>
                                                {groupsData.administrators.map(admin => (
                                                    <div key={admin.id} className="role-card admin">
                                                        <strong>{admin.fname} {admin.lname}</strong>
                                                        <span className="role-card-tag">(Administrator)</span>
                                                        <div className="role-card-perms">✓ Can View &nbsp; ✓ Can Edit &nbsp; ✓ Can Delete</div>
                                                    </div>
                                                ))}
                                            </div>

                                            <div className="role-block">
                                                <p className="role-block-title leader">Group Leader <span>(Auto)</span></p>
                                                <div className="role-card leader">
                                                    <strong>{selectedGroup.leader_name}</strong>
                                                    <span className="role-card-tag">(Leader)</span>
                                                    <div className="role-card-perms">✓ Can View &nbsp; ✓ Can Edit &nbsp; ✓ Can Delete</div>
                                                </div>
                                            </div>

                                            <div className="role-block">
                                                <p className="role-block-title member">Group Members</p>
                                                {selectedGroup.members.filter(m => m.id != selectedGroup.leader_id).map(member => {
                                                    const isSelected = !!permissions[member.id];
                                                    const isSelf = String(member.id) === String(loggedInUserId) && userType === 'member';
                                                    const isDisabled = userType === 'member' || isSelf;
                                                    return (
                                                        <div key={member.id} className={`member-card ${isSelected ? 'selected' : ''}`}>
                                                            <label className="member-card-label">
                                                                <input type="checkbox" checked={isSelected || isSelf} disabled={isDisabled} onChange={(e) => toggleMember(member.id, e.target.checked)} />
                                                                {member.fname} {member.lname} {isSelf && <span className="member-self-tag">(You)</span>}
                                                                <span className="member-role-tag">({member.usertype})</span>
                                                            </label>
                                                            {isSelected && (
                                                                <div className="member-permissions-row">
                                                                    <label><input type="checkbox" checked={!!permissions[member.id]?.can_view} onChange={(e) => handlePermissionChange(member.id, 'can_view', e.target.checked)} /> Can View</label>
                                                                    <label><input type="checkbox" checked={!!permissions[member.id]?.can_edit} onChange={(e) => handlePermissionChange(member.id, 'can_edit', e.target.checked)} /> Can Edit</label>
                                                                    <label><input type="checkbox" checked={!!permissions[member.id]?.can_delete} onChange={(e) => handlePermissionChange(member.id, 'can_delete', e.target.checked)} /> Can Delete</label>
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    )}
                </div>

                {/* ===== NOTES / DESCRIPTION ===== */}
                <div className="form-section-card">
                    <div className="section-card-heading compact">
                        <div className="section-title-wrap">
                            <div className="section-icon">📝</div>
                            <div>
                                <h3>Notes / Description</h3>
                            </div>
                        </div>
                    </div>
                    <div className="description-editor">
                        <div className="description-toolbar">
                            <button type="button">B</button><button type="button">I</button><button type="button">U</button>
                        </div>
                        <textarea value={formData.notes} onChange={(e) => setFormData({ ...formData, notes: e.target.value })} />
                    </div>
                </div>

                {/* ===== ITEMS SECTION ===== */}
                <div className="form-section-card">
                    <div className="section-card-heading compact">
                        <div className="section-title-wrap">
                            <div className="section-icon">🛒</div>
                            <div>
                                <h3>Items</h3>
                                <p>Add vehicles or items to this invoice.</p>
                            </div>
                        </div>
                        <button type="button" className="btn-add-item" onClick={addItem}>+ Add Items</button>
                    </div>

                    <div className="items-table-scroll">
                        <table className="items-table">
                            <thead>
                                <tr>
                                    <th>Chassis / Item Name</th>
                                    <th>Description</th>
                                    <th>Qty</th>
                                    <th>Price</th>
                                    <th>Tax Rate</th>
                                    <th className="text-center">Total</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.length === 0 ? (
                                    <tr>
                                        <td colSpan="7" style={{ textAlign: 'center', padding: '15px', color: '#888' }}>
                                            No items added. Click "Add Items" to add a new Chassis.
                                        </td>
                                    </tr>
                                ) : (
                                    items.map((item, index) => (
                                        <tr key={`item-${index}`}>
                                            <td>
                                                <select
                                                    value={item.item_name}
                                                    onChange={(e) => handleItemChassisChange(index, e.target.value)}
                                                >
                                                    <option value="">Select Chassis</option>
                                                    {filteredChassis.map((chassis, chassisIndex) => {
                                                        const chassisValue = typeof chassis === 'string' ? chassis : (chassis.chassis_number || chassis.chassis || '');
                                                        return (
                                                            <option key={`chassis-${chassisIndex}`} value={chassisValue}>
                                                                {chassisValue}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </td>
                                            <td><input type="text" value={item.description} onChange={(e) => handleItemChange(index, 'description', e.target.value)} /></td>
                                            <td><input type="number" value={item.qty} onChange={(e) => handleItemChange(index, 'qty', e.target.value)} /></td>
                                            <td><input type="number" value={item.price} onChange={(e) => handleItemChange(index, 'price', e.target.value)} /></td>
                                            <td><select value={item.tax_rate} onChange={(e) => handleItemChange(index, 'tax_rate', e.target.value)}><option>No Tax</option><option>5%</option><option>10%</option></select></td>
                                            <td className="item-total-cell">{item.total}</td>
                                            <td className="text-center"><button type="button" className="items-table-remove-btn" onClick={() => removeItem(index)}>×</button></td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* ===== BOTTOM TOTALS ===== */}
                <div className="sale-order-bottom-area">
                    <div className="sale-order-summary-note">
                        <div className="summary-note-icon">i</div>
                        <div>
                            <strong>Terms & Conditions</strong>
                            <p>Total is calculated based on all items added. Discount & Adjustment will adjust the final amount.</p>
                        </div>
                    </div>
                    <div className="sale-order-totals">
                        <div className="total-row"><strong>Sub Total:</strong><span>{formData.sub_total}</span></div>
                        <div className="total-row"><label>Discount (%)</label><input type="number" value={formData.discount} onChange={(e) => { setFormData({ ...formData, discount: e.target.value }); calculateTotals(items); }} /></div>
                        <div className="total-row"><label>Adjustment</label><input type="number" value={formData.adjustment} onChange={(e) => { setFormData({ ...formData, adjustment: e.target.value }); calculateTotals(items); }} /></div>
                        <div className="total-row final"><span>Total:</span><span>{formData.total}</span></div>
                    </div>
                </div>

                <div className="form-submit-row">
                    <button type="submit" className="btn-blue final-save-btn" disabled={saving}>{saving ? 'Saving...' : 'Save Invoice'}</button>
                </div>
            </form>
        </div>
    );
};

export default NewInvoiceForm;